<template>
    <div>
        <label for="signatureBox">{{ element.text }}</label>
        <div id="signatureBox" class="text-center">
            <h4>Auf mobilen Geräten kann hier unterschrieben werden.</h4>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SignatureElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>
    #signatureBox {
        background-color: lightgray;
        border: 1px dotted gray;
        padding: 20px;
    }

    h4 {
        color: white;
    }
</style>